import SearchBox from "../SearchBox/SearchBox";

export default class SearchField {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.search-field'), el => {
            SearchBox.applyAutocomplete(el);
        });
    }
}
